<template lang='pug'>
    crud-form( v-bind='formProps' @reset='reset' @submitForm='submitForm' )
</template>

<script>
//
import { mapActions, mapState } from 'vuex'
import { CrudForm } from '@/components/reusable_components'
import EmployeeService from '@/services/api/employee'
import { removeRUTHyphen } from '@/services/RUTFormatter'
//
import { EmployeeFields } from './fields'
import RUTUtils from '@/mixins/reusable_mixins/RUTUtils.js'
//
export default {
    components: {
        'crud-form': CrudForm,
    },
    mixins:[RUTUtils],
    computed: {
        /**
         *
         */
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),

        /**
         *
         */
        formProps() {
            return {
                editable: this.$can('EDIT_EMPLOYEE'),
                readOnly: !this.$can('EDIT_EMPLOYEE'),
                fields: EmployeeFields,
                loading: this.loading,
                ref: 'form',
            }
        },
    },
    data() {
        return {
            loading: false,
            selected: null,
            tab: 'general',
        }
    },
    methods: {
        /**
         *
         */

        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
        ...mapActions('EmployeeModule', {
            setEmployee: 'setEmployee',
        }),

        /**
         *
         */
        async reset() {
            //
            this.loading = true

            //
            const employee = await EmployeeService.fetchById(
                this.$route.params.id
            )

            //
            this.$refs.form.vmodels.rut = removeRUTHyphen(employee.rut)
            this.$refs.form.vmodels.names = employee.names
            this.$refs.form.vmodels.last_name1 = employee.last_name1
            this.$refs.form.vmodels.last_name2 = employee.last_name2
            this.$refs.form.vmodels.email = employee.email
            this.setEmployee(employee)
            //
            this.loading = false
        },

        /**
         *
         */
        showSnackbar(type, title, message) {
            this.initSnackbar(this.fillSnack(type, title, message))
        },

        /**
         *
         */
        async submitForm(event) {
            //
            
            event.rut = this.mixRUTFormatter(event.rut)
            const response = await EmployeeService.update(
                this.$route.params.id,
                {
                    ...event,
                }
            )

            //
            switch (response.status) {
                case 'error':
                    this.resetSnackbarState()
                    this.showSnackbar(
                        'error',
                        'Error.',
                        response.error || response.message
                    )
                    break
                case 'success':
                    this.resetSnackbarState()
                    this.showSnackbar(
                        'success',
                        'Éxito.',
                        'Datos del empleado actualizados con éxito.'
                    )
                    break
                default:
                    break
            }
        },
    },
    mounted() {
        this.reset()
    },
    watch: {
        /**
         *
         */
        $route() {
            this.reset()
        },
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_DETAIL_EMPLOYEE')) ctx.$router.push('/')
        })
    },
}
</script>

